import {signedDownloadCache} from './SignedDownloadCache';
import { LOG_IN, LOG_OUT } from '../common/endpoints';
import { IUser } from '../models/IUser';
import {AuthContext} from '../models/AuthContext';
import { baseAPI } from './BaseAPI';

export const authAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getAuthContext: build.query<AuthContext, void>({
            query: () => ({
                url: 'auth/me',
                method: 'GET',
            }),
            providesTags: ['Auth'],
        }),

        logIn: build.mutation<IUser, string[]>({
            async onQueryStarted(_args, {queryFulfilled}) {
                try { await queryFulfilled; signedDownloadCache.clear(); } catch { /* Keep the active session cache after rejected login. */ }
            },
            query: (data: string[]) => ({
                url: LOG_IN,
                method: 'POST',
                body: {
                    email: data[0],
                    password: data[1],
                },
            }),
            invalidatesTags: (_result, error) => error ? [] : ['Auth', 'User'],
        }),

        logOut: build.mutation<void, void>({
            onQueryStarted() { signedDownloadCache.clear(); },
            query: () => ({
                url: LOG_OUT,
                method: 'POST',
            }),

            invalidatesTags: ['Auth', 'User'],
        }),
    }),
});


